import { FullScreenBackgroundContainer } from "@/components/container/full-screen-background-container";
import { DEFAULT_AUTHENTICATED_ROUTE } from "@/constants/app-routes";
import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { removeSplashScreen } from "@/main";
import { resolveSignedOutRoute } from "@/utils/auth/resolve-auth-destination";
import { hasSignedInBefore } from "@/utils/has-signed-in-before";
import { IonSpinner, useIonRouter } from "@ionic/react";
import { useEffect, useRef } from "react";

const SplashScreen = () => {
  const navigation = useIonRouter();
  // The effect re-runs whenever `navigation` identity changes, re-arming the timer.
  // Latch so the branded splash navigates at most once per mount.
  const hasNavigatedRef = useRef(false);

  useEffect(() => {
    removeSplashScreen();
    // Resolve the destination immediately: the branded delay is now owned by the single
    // <AppSplash> overlay (which covers this navigation), so a second timed delay here
    // would only leave the user staring at the overlay's spinner longer than needed.
    const timer = setTimeout(() => {
      if (hasNavigatedRef.current) return;
      hasNavigatedRef.current = true;
      const token = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN_KEY);
      // A token means signed-in → land on the main app; AuthRouteGuard then bounces
      // an un-onboarded user to /get-started. No token → resolve login vs register.
      const target = token
        ? DEFAULT_AUTHENTICATED_ROUTE
        : resolveSignedOutRoute(hasSignedInBefore());
      navigation.push(target, "forward", "replace");
    }, 0);

    return () => clearTimeout(timer);
  }, [navigation]);

  return (
    <FullScreenBackgroundContainer
      imageClassName="bg-violet-950"
      className="flex flex-col items-center justify-center"
      backdrop={false}
    >
      <div className="flex w-full max-w-sm flex-col items-center gap-8">
        {/* <img
          src="/assets/images/splash-animation.gif"
          alt="NutriCoach"
          className="w-[392px]"
        /> */}
        <IonSpinner name="crescent" className="h-12 w-12 text-white" color="light" />
      </div>
    </FullScreenBackgroundContainer>
  );
};

export default SplashScreen;
